import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { selectUnderwriting } from './underwriting.selectors';

const selectUnderwritingSettings = createSelector(selectUnderwriting, ({ settings }) => settings);

const selectUnderwritingSettingValues = createSelector(selectUnderwritingSettings, Object.values);

export const selectFilteredUnderwritingSettings = createSelector(
  getDebouncedSearchValue,
  selectUnderwritingSettingValues,
  searchItems(({ name }) => [name]),
);
